import { FormModal } from "../../../../components/modals/form-modal/form-modal.component";

import { FlyerCreateForm } from "../flyer-create-form/flyer-create-form.component";
import { flyerCreateFormValidation } from "../../types/flyer-create-form/flyer-create-form.validation";
import { FlyerCreateModalProps } from "./flyer-create-modal.props";

export const FlyerCreateModal = (props: FlyerCreateModalProps) => (
  <FormModal
    defaultValues={{
      name: "",
      startAt: "",
      endAt: "",
      wtwReviewDate: "",
      wtwSeniorReviewDate: "",
    }}
    Form={FlyerCreateForm}
    formValidation={flyerCreateFormValidation}
    isOpen={props.isOpen}
    modalErrors={props.errors}
    modalTitle="New Design Layout"
    onClose={props.onClose}
    submit={props.onSubmit}
  />
);
